import { Chart } from 'frappe-charts/dist/frappe-charts.esm.js'

frappe.Chart = Chart;